export default __webpack_public_path__ + "static/media/business-pro-wide-min.fd5d7172.jpg";